module.exports = __webpack_public_path__ + "static/media/complete-graphic.57d1482b.svg";